export enum RoutePaths {
  ACCOUNT = 'account',
  ACCOUNT_CHANGE = 'account-change',
  ACCOUNT_INFORMATION = 'account-information',
  ACCOUNT_TRANSFER = 'account-transfer',
  ACCOUNT_REMEDIATION = 'account-remediation',
  ARRANGEMENT_TO_PAY = 'arrangement-to-pay',
  ARREARS = 'arrears',
  BASE_RATE_CHANGES = 'baseRateChanges',
  BASE_RATE_TYPES = 'baseRateTypes',
  BUSINESS_RULES = 'business-rules',
  BREATHING_SPACE = 'breathing-space',
  CALLS = 'calls',
  COMPLAINTS = 'complaints',
  COVENANTS = 'covenants',
  CURRENT_EXPOSURE = 'current-exposure',
  CUSTOMER_CENTRIC = 'entity',
  CUSTOMER_CENTRIC_DASHBOARD = 'relationships-dashboard',
  CUSTOMER_CENTRIC_DOCUMENTS = 'documents',
  CUSTOMER_CENTRIC_KYC = 'kyc',
  CUSTOMER_CENTRIC_NOTES = 'notes',
  CUSTOMER_CENTRIC_RELATIONSHIPS = 'relationships',
  CUSTOMER_CENTRIC_VULNERABILITY = 'vulnerability',
  CUSTOMERS = 'customers',
  CUSTOMERS_FINANCIAL_CRIME = 'financial-crime',
  CUSTOMERS_GDPR = 'gdpr',
  CUSTOMERS_INSOLVENCY = 'insolvency',
  CUSTOMERS_KYC = 'customers-kyc',
  CUSTOMERS_OVERVIEW = 'customers-overview',
  CUSTOMERS_VULNERABILITY = 'customers-vulnerability',
  CUSTOMERS_ADDITIONAL_SUPPORT_NEEDS = 'customers-additional-support-needs',
  DD_MANAGEMENT = 'dd-management',
  DIARIES = 'diaries-and-standing-data',
  DOCUMENTS = 'documents',
  DUE_DAY_CHANGE = 'due-day-change',
  ENTITIES = 'entities',
  ENTITIES_OVERVIEW = 'entities-overview',
  EXIT_MODULES = 'exit-modules',
  FIELD_AGENT = 'field-agent',
  FLEXIBLE_FEATURE = 'flexible-feature',
  FULL_REDEMPTIONS = 'full-redemptions',
  GOVERNMENT_SCHEME = 'government-scheme',
  GROUP_CONFIG = 'groupConfig',
  GROUP_EXPOSURE = 'GroupExposure',
  GROUPEXPOSURE_KYC = 'kyc',
  HIGH_RISK_JURISDICTION = 'high-risk-jurisdiction',
  HOME = '',
  INCOME_EXPENDITURE = 'income-expenditure',
  INTEREST_CHARGE_HISTORY = 'interest-charge-history',
  AMORTISATION_PROFILE = 'amortisation-profile',
  INVOICE = 'invoice',
  LITIGATION = 'litigation',
  NON_STANDARD_COSTS = 'non-standard-costs',
  NOTES = 'notes',
  OVERPAYMENT = 'overpayment',
  PAYMENT_HOLIDAY = 'payment-holiday',
  PAYMENT_REVIEW = 'payment_review',
  PENDING_DOCUMENTS = 'pending-documents',
  PRODUCT_SWITCH = 'product-switch',
  PRODUCT_SWITCH_UPDATE = 'product-switch-update',
  RECEIVERSHIP = 'receivership',
  REFUNDS = 'refunds',
  REPAYMENT_STRATEGY = 'repayment-strategy',
  REPAYMENT_STRATEGY_EXPOSURE = 'repayment-strategy-exposure',
  RESTRUCTURE = 'restructure',
  RETENTIONS = 'retentions',
  DRAWDOWN = 'drawdown',
  SEARCH = 'search',
  SEARCH_CHILD = 'search/:id',
  SECURITY = 'security',
  SECURITY_ABANDONMENT = 'security-abandonment',
  SECURITY_AMENDMENTS_ORDERS = 'security-amendments-orders',
  SECURITY_DEEDS_TRACKER = 'security-deeds-tracker',
  SECURITY_DEMANDS = 'security-demands',
  SECURITY_INSURANCE = 'security-insurance',
  SECURITY_LETTINGS = 'security-lettings',
  SECURITY_OVERVIEW = 'security-overview',
  SECURITY_PARTIAL_RELEASES = 'security-partial-releases',
  SECURITY_TITLE_CHARGES = 'title-charges',
  VALUATIONS = 'security-valuation',
  SECURITY_VOLUNTARY_SURRENDER = 'security-voluntary-surrender',
  SECURITY_OCCUPANTS = 'security-occupants',
  SHORTCUTS = 'shortcuts',
  SOURCE_OF_FUND_REDEMPTIONS = 'source-of-funds-redemptions',
  SOURCE_OF_FUND = 'source-funds',
  SUPER_USER = 'superUser',
  SUSPICIOUS = 'suspicious',
  TARIFF_OF_CHARGES = 'tariffOfCharges',
  BRAND_SETTINGS = 'brandSettings',
  CASE_OWNER_ALLOCATION = 'case-owner-allocation',
  ROLL_LOAN_ENGINE = 'rollLoanEngine',
  THIRD_PARTY = 'ThirdParty',
  TRANSACTION = 'transaction',
  TRANSACTION_CODES = 'transactionCodes',
  TRANSACTIONS = 'transactions',
  UNAUTHORIZED = 'unauthorized',
  CUSTOMERS_BTL_CCJ = 'buy-to-let-ccj',
  JOB_SCHEDULER = 'job-scheduler',
  SECURITY_HMO = 'security-house-multiple-occupants',
  MANDATES = 'mandates',
}

export enum MenuRoutePaths {
  ACCOUNT_TRANSFER = '/account-transfer',
  BASE_RATE_CHANGES = '/baseRateChanges',
  BASE_RATE_TYPES = '/baseRateTypes',
  BUSINESS_RULES = '/business-rules',
  CUSTOMER_CENTRIC = '/entity',
  GROUP_CONFIG = '/groupConfig',
  GROUP_EXPOSURE = '/GroupExposure',
  HIGH_RISK_JURISDICTION = '/high-risk-jurisdiction',
  SUPER_USER_ROLES_AND_PERMISSIONS = '/superUser/rolesAndPermissions',
  SUPER_USER_SCOPES_GROUPS = '/superUser/scopesGroups',
  SUPER_USER_USERS = '/superUser/users',
  TARIFF_OF_CHARGES = '/tariffOfCharges',
  BRAND_SETTINGS = '/brandSettings',
  CASE_OWNER_ALLOCATION = '/case-owner-allocation',
  ROLL_LOAN_ENGINE = '/rollLoanEngine',
  THIRD_PARTY = '/ThirdParty',
  TRANSACTION = '/transaction',
  TRANSACTION_CODES = '/transactionCodes',
  JOB_SCHEDULER = '/job-scheduler',
  MANDATES = '/mandates',
}
